import { render, staticRenderFns } from "./UseOnlineSocket.vue?vue&type=template&id=70088f7e&scoped=true&"
import script from "./UseOnlineSocket.vue?vue&type=script&lang=js&"
export * from "./UseOnlineSocket.vue?vue&type=script&lang=js&"
import style0 from "./UseOnlineSocket.vue?vue&type=style&index=0&id=70088f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70088f7e",
  null
  
)

export default component.exports